import React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';

import { Login } from '@ledium/ui-login';

import { PageErrorBoundary } from './components/PageErrorBoundary';
import { RouteConfig, routeConfig } from './config/routeConfig';
import usePageConfig from './hooks/usePageConfig';
import { useGlobalStore } from './store/globalStore/context/globalContext';
import { PageStoreProvider } from './store/pageStore/context/pageContext';

interface RouteParams {
    pageType?: string;
    itemId?: string;
}

interface PrivateRouteProps {
    item: RouteConfig;
    path: string;
}

const LediumRouter = () => {
    const {
        globalState: { userData }
    } = useGlobalStore();

    const PrivateRoute = ({ item, path }: PrivateRouteProps) => {
        usePageConfig(item.pageName);
        // eslint-disable-next-line
        return (<Route exact path={path} render={({ match }: RouteComponentProps<RouteParams>) => {
                    const { pageType, itemId } = match.params;
                    if (userData.auth) {
                        if (item.MenuComponent && (!pageType || (pageType !== 'view' && userData.admin !== true) || (pageType !== 'new' && !itemId))) {
                            return <item.MenuComponent />;
                        }
                        return (
                            <PageErrorBoundary>
                                <item.Component />
                            </PageErrorBoundary>
                        );
                    }
                    return <Redirect to={{ pathname: '/login' }} />;
                }}
            />
        );
    };

    return (
        <>
            {/* eslint-disable-next-line*/}
            <Route exact path="/login" render={() => userData.auth
                ? <Redirect to={{ pathname: '/' }}/>
                : <Login/>
            }/>

            {routeConfig.map((item, idx) => (
                <PageStoreProvider key={idx}>
                    <PrivateRoute item={item} path={`${item.path}`} />
                </PageStoreProvider>
            ))}
        </>
    );
};

export default LediumRouter;
